export default ({
  white, attach, theme, CARD, CARD_ACTION_AREA
}) => ({
  MuiCard: {
    root: {
      [attach(CARD.root)]: {
        backgroundColor: white.text,
        margin: '2px auto',
        width: '100%',
        overflow: 'visible'
      }
    }
  },
  MuiCardHeader: {
    root: {
      padding: '10px 10px 5px',
      borderBottom: '1px solid #CCCCCC'
    },
    title: {
      fontSize: 20,
      fontWeight: 700,
      color: theme.palette.primary.main,
      padding: '0 10px',
      textAlign: 'left',
      lineHeight: '25px'
    }
  },
  MuiCardContent: {
    root: {
      padding: '5px 10px'
    }
  },
  MuiCardActionArea: {
    root: {
      [attach(CARD_ACTION_AREA.root)]: {
        cursor: 'auto'
      },
      [attach(CARD_ACTION_AREA.highlighted)]: {
        backgroundColor: '#ffffd4'
      }
    }
  }
});
